import React from "react";
import { Link, Outlet } from "react-router-dom";
import styles from "./AdminDashboard.module.css";

const AdminDashboard = () => {
  return (
    <div className={styles.adminContainer}>
      {/* 사이드바 */}
      <nav className={styles.sidebar}>
        <h2>관리자 메뉴</h2>
        <ul>
          <li>
            <Link to="/admin/users">회원 관리</Link>
          </li>
          <li>
            <Link to="/admin/companies">회사 관리</Link>
          </li>
          <li>
            <Link to="/admin/related-videos">Related Videos</Link>
          </li>
          <li>
            <Link to="/admin/stock-price">Stock Price</Link>
          </li>
          <li>
            <Link to="/admin/market-sketch">Market Sketch</Link>
          </li>
          <li>
            <Link to="/admin/library">Library 관리</Link>
          </li>
        </ul>
      </nav>

      {/* 메인 컨텐츠 */}
      <div className={styles.content}>
        <Outlet /> {/* 여기에 각 페이지 컴포넌트가 렌더링됨 */}
      </div>
    </div>
  );
};

export default AdminDashboard;
